import { Router } from '@lightningjs/sdk';
import _get from 'lodash/get';
import { HISTORY_CLEANUP_PAGES } from '../routes.utils';
import { sendPageView, sendPrintEvent } from '../../../logic/analytics/analytics.utils';

export const afterEachRoute = destination => {
  const url = _get(destination, 'url', '');

  if (url && HISTORY_CLEANUP_PAGES.includes(url)) {
    Router.setHistory([]);
  }

  sendPageView(destination.url);
  sendPrintEvent('ViewContent');
};
